import { SVGProps } from '../types';
const IdealIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M23.1099 6.60791C30.44 6.60809 33.2563 10.7323 33.2563 15.9448C33.2562 22.1798 29.3196 25.3138 23.1099 25.314H12.3218V6.60791H23.1099ZM13.3462 24.2583H23.1089C28.9989 24.2583 32.2007 21.4206 32.2007 15.9771C32.2005 10.3688 28.7426 7.72998 23.1089 7.72998H13.3462V24.2583ZM17.7954 22.8726H14.6577V17.1323H17.7954V22.8726ZM16.2271 12.2495C17.3053 12.2498 18.1792 13.1509 18.1792 14.2622C18.179 15.3734 17.3052 16.2746 16.2271 16.2749C15.149 16.2746 14.2741 15.3734 14.2739 14.2622C14.2739 13.1509 15.1489 12.2498 16.2271 12.2495Z"
      fill="black"
    />
    <path
      d="M23.1094 9.0163C26.6305 9.0163 30.5041 10.1379 30.8564 15.1852H29.5439V12.4147H28.6475V16.1091H30.8877C30.7917 20.134 28.8393 22.8727 23.1094 22.8727H19.3643V16.1091H19.9404C20.9326 16.1091 21.5409 15.4168 21.541 14.2624C21.541 13.1077 20.9325 12.4147 19.9082 12.4147H19.3643V9.0163H23.1094ZM22.085 16.1091H24.3262V15.1852H23.0137V14.6911H24.1982V13.7673H22.9814V13.3386H24.2617V12.4147H22.085V16.1091ZM24.71 16.1091H25.6699L25.8623 15.4167H27.0469L27.2393 16.1091H28.167L27.0791 12.4147H25.7979L24.71 16.1091ZM19.9082 13.3386C20.2603 13.3386 20.6445 13.4376 20.6445 14.2624C20.6444 15.0868 20.2923 15.1852 19.9082 15.1852H19.3643V13.3386H19.9082ZM26.1182 14.4929V14.4597H26.1279L26.1182 14.4929ZM26.7588 14.4597H26.1279L26.4385 13.4372H26.4707L26.7588 14.4597Z"
      fill="#D50072"
    />
  </svg>
);

export { IdealIcon };
